const furnishingTypes = [
	{ code: "unfurnished", name: "Bareshell" },
	{ code: "furnished", name: "Partially Furnished" },
];

export default furnishingTypes;
